const ipPartRegex = '(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?){1}'; // 0-255
const subnetMaskPattern = '(?:/(3[0-2]|[12]?[0-9]))?'; // 0-32

export const ipValidationRegex = new RegExp(
  `^${ipPartRegex}\\.${ipPartRegex}\\.${ipPartRegex}\\.${ipPartRegex}${subnetMaskPattern}$`,
);
